module.exports = __webpack_public_path__ + "static/media/journey-right-trees-behind-hill.4fee9d71.svg";